import React, { useMemo } from "react";

// Definimos las tres fases principales y sus correspondientes “fin”
const mainStages = [
  {
    key: "GESTIÓN DOCUMENTAL",
    label: "Gestión Doc.",
    finishKey: "FIN GESTIÓN DOCUMENTAL",
  },
  { key: "FACTURACIÓN", label: "Facturación", finishKey: "FIN FACTURACIÓN" },
  { key: "CIERRE PROYECTO", label: "Cierre Proyecto", finishKey: null },
];

const TimeLineAdmin = ({ phasesData }) => {
  // 1 --> Incluimos TODAS las actividades (fases e hijos)
  const modeledData = useMemo(
    () =>
      phasesData.map(({ id, parentId, title, start, end, progress }) => ({
        id,
        parentId,
        title,
        start,
        end,
        progress: progress ?? 0,
      })),
    [phasesData]
  );

  // 2 -->  hacemos un filtro por el titulo
  const byTitle = useMemo(() => {
    const map = {};
    modeledData.forEach((p) => {
      map[p.title] = p;
    });
    return map;
  }, [modeledData]);

  // 3--> Para cada fase, agreamos los hijos y finishKey
  const stages = useMemo(
    () =>
      mainStages.map(({ key, label, finishKey }) => {
        const phase = byTitle[key];
        if (!phase) return { key, label, start: null, end: null, progress: 0 };

        // --- fecha inicio => min entre hijos o la misma ---
        const hijos = modeledData.filter((p) => p.parentId === phase.id);
        const fechasIni = hijos.length
          ? hijos.map((h) => new Date(h.start))
          : [new Date(phase.start)];
        const minStart = new Date(Math.min(...fechasIni));

        // --- Fecha fin : max entre hijos o propio ---
        const fechasFinFase = hijos.length
          ? hijos.map((h) => new Date(h.end))
          : [new Date(phase.end)];
        let maxEnd = new Date(Math.max(...fechasFinFase));

        // --- pctcompletado  ---
        let progress = phase.progress;

        // --- Si hay finishKey: usamos su progreso y extendemos la fecha fin ---
        if (finishKey && byTitle[finishKey]) {
          const fin = byTitle[finishKey];
          const hijosFin = modeledData.filter((p) => p.parentId === fin.id);
          const fechasFin = hijosFin.length
            ? hijosFin.map((h) => new Date(h.end))
            : [new Date(fin.end)];
          const maxEndFin = new Date(Math.max(...fechasFin));

          // Si la fase de cierre llegó a 100%, marcamos 100
          progress = fin.progress === 100 ? 100 : phase.progress;

          // Tomamos la fecha fin más lejana (fase o cierre)
          if (maxEndFin > maxEnd) maxEnd = maxEndFin;
        }

        return {
          key,
          label,
          start: minStart.toISOString(),
          end: maxEnd.toISOString(),
          progress,
        };
      }),
    [modeledData, byTitle]
  );

  // formateamos
  const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <div className="timeline-container">
      {stages.map((stage, idx) => {
        const progress = stage.progress;
        const isCompleted = progress === 100;
        const isOngoing = progress > 0 && progress < 100;
        const isPending = progress === 0;

        // clase para la bolita
        const stateClass = isCompleted
          ? "state-circle completed"
          : isOngoing
          ? "state-circle current"
          : "state-circle pending";

        // Texto de estado
        const labelText = isCompleted
          ? "Completado"
          : isOngoing
          ? "En Curso"
          : "Pendiente";

        return (
          <React.Fragment key={stage.key}>
            <div className="state-container">
              <div className="state-name">{stage.label}</div>

              <div className={stateClass}>
                {isCompleted || isOngoing ? `${progress}%` : "0%"}
              </div>

              <div className="date-label">
                <div className="date-item">
                  <i className="fa fa-play mr-2 text-secondary"></i>
                  {formatDate(stage.start)}
                </div>
                <div className="date-item">
                  <i className="fa fa-flag-checkered mr-2 text-secondary"></i>
                  {formatDate(stage.end)}
                </div>
              </div>

              <div className="status-label">{labelText}</div>
            </div>

            {idx < stages.length - 1 && (
              <div className="arrow-container">
                <i className="bi bi-arrow-right-short arrow-icon fw-bold text-primary"></i>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TimeLineAdmin;
